export const getBlockStyle = (block) => {
  switch (block.getType()) {
    case 'header-one':
      return 'H1';
    case 'header-two':
      return 'H2';
    case 'header-three':
      return 'H3';
    case 'unordered-list-item':
      return 'custom-unordered-list-item';
    case 'ordered-list-item':
      return 'custom-ordered-list-item';
    default:
      return null;
  }
};